import React from "react";
import ParentRoute from "../../../common/components/ParentRoute";

export default function MonitorsWrapper(props) {
  return <ParentRoute {...props} nobreadcrumbs={true} />;
}
